import { z } from 'zod';

export const newVoterSchema = z
  .object({
    firstName: z
      .string()
      .min(1, 'First name is required')
      .max(100, 'First name must be less than 100 characters'),
    lastName: z
      .string()
      .min(1, 'Last name is required')
      .max(100, 'Last name must be less than 100 characters'),
    fatherName: z
      .string()
      .min(1, 'Father name is required')
      .max(191, 'Father name must be less than 191 characters'),
    motherName: z
      .string()
      .min(1, 'Mother name is required')
      .max(191, 'Mother name must be less than 191 characters'),
    email: z
      .string()
      .email('Please provide a valid email address')
      .max(100)
      .optional()
      .or(z.literal('')),
    phoneNumber: z
      .string()
      .max(20, 'Phone number must be less than 20 characters')
      .optional()
      .or(z.literal('')),
    votingVillageId: z.string().min(1, 'Voting village is required'),
    originalVillageId: z.string().optional(),
    genderId: z.string().min(1, 'Gender is required'),
    dateOfBirth: z.string().min(1, 'Date of birth is required'),
    placeOfBirth: z
      .string()
      .max(100, 'Place of birth must be less than 100 characters')
      .optional()
      .or(z.literal('')),
    address: z
      .string()
      .max(255, 'Address must be less than 255 characters')
      .optional()
      .or(z.literal('')),
    passportNumber: z
      .string()
      .max(50, 'Passport number must be less than 50 characters')
      .optional()
      .or(z.literal('')),
    drivingLicenseNumber: z
      .string()
      .max(50, 'Driving license number must be less than 50 characters')
      .optional()
      .or(z.literal('')),
    otherIdType: z
      .string()
      .max(100, 'Other ID type must be less than 100 characters')
      .optional()
      .or(z.literal('')),
    otherIdNumber: z
      .string()
      .max(100, 'Other ID number must be less than 100 characters')
      .optional()
      .or(z.literal('')),
    reason: z
      .string()
      .max(500, 'Reason must be less than 500 characters')
      .optional()
      .or(z.literal('')),
    // Location fields for cascading dropdowns
    province: z.string().min(1, 'Province is required'),
    district: z.string().min(1, 'District is required'),
    sector: z.string().min(1, 'Sector is required'),
    cell: z.string().min(1, 'Cell is required'),
    village: z.string().min(1, 'Village is required')
  })
  .refine((data) => data.email || data.phoneNumber, {
    message: 'Either email or phone number must be provided',
    path: ['email']
  });

export type NewVoterFormValues = z.infer<typeof newVoterSchema>;
